import { render } from "./SampleValidationTabs.vue?vue&type=template&id=195afcd8"
import script from "./SampleValidationTabs.vue?vue&type=script&lang=js"
export * from "./SampleValidationTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__